// Port of api/fuel/app/classes/insights/game/context.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'context',
    priority: 3,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)

        var collection = this._data.collection
        var rating = this._data.rating
        var playsRaw = this._data.plays_raw

        // --- COLLECTION ---
        var collectionData = { active: false }

        if (collection) {
            var own = parseInt(collection.get_own(), 10) || 0
            var prevowned = parseInt(collection.get_prevowned(), 10) || 0
            var dateOwned = parseInt(collection.get_date_owned(), 10) || 0

            collectionData = {
                active: true,
                own: own,
                prevowned: prevowned,
                dateOwned: dateOwned,
                dateRemoved: null
            }

            if (prevowned && !own) {
                var ownLogs = Util.queryFast(
                    'SELECT log_context, log_date FROM log_user_collection_status ' +
                    'WHERE user_id = ' + user_id + ' AND game_id = ' + game_id +
                    ' AND log_status = ' + Constants.COLLECTION_STATUS_OWN +
                    ' ORDER BY log_date DESC LIMIT 1'
                )

                if (ownLogs.length && parseInt(ownLogs[0].log_context, 10) === Constants.LOG_CONTEXT_REMOVED) {
                    collectionData.dateRemoved = parseInt(ownLogs[0].log_date, 10)
                }
            }
        }

        // --- RATING ---
        var ratingData = { active: false }

        if (rating) {
            ratingData = {
                active: true,
                value: parseFloat(rating.get_rating_value()) || 0,
                date: parseInt(rating.get_date(), 10) || 0
            }
        }

        // --- PLAYS ---
        var playsData = { active: false }

        if (playsRaw.length) {
            var firstPlay = null
            var lastPlay = null

            for (var i = 0; i < playsRaw.length; i++) {
                var date = parseInt(playsRaw[i].play_date, 10) || 0
                if (firstPlay === null || date < firstPlay) firstPlay = date
                if (lastPlay === null || date > lastPlay) lastPlay = date
            }

            playsData = {
                active: true,
                total: this._data.totalPlays,
                sessions: this._data.totalSessions,
                firstPlay: firstPlay,
                lastPlay: lastPlay
            }
        }

        // --- WISHLIST ---
        var wishlistData = { active: false }

        var isCurrentlyWishlisted = collection && parseInt(collection.get_wishlist(), 10)

        var wishLogs = Util.queryFast(
            'SELECT log_context, log_date FROM log_user_collection_status ' +
            'WHERE user_id = ' + user_id + ' AND game_id = ' + game_id +
            ' AND log_status = ' + Constants.COLLECTION_STATUS_WISHLIST +
            ' ORDER BY log_date ASC'
        )

        if (isCurrentlyWishlisted || wishLogs.length) {
            var wishAddDate = null
            var wishRemoveDate = null

            for (var wi = 0; wi < wishLogs.length; wi++) {
                var ctx = parseInt(wishLogs[wi].log_context, 10)
                if (ctx === Constants.LOG_CONTEXT_ADDED) {
                    wishAddDate = parseInt(wishLogs[wi].log_date, 10)
                } else if (ctx === Constants.LOG_CONTEXT_REMOVED) {
                    wishRemoveDate = parseInt(wishLogs[wi].log_date, 10)
                }
            }

            wishlistData = {
                active: true,
                current: isCurrentlyWishlisted ? true : false,
                dateAdded: wishAddDate,
                dateRemoved: wishRemoveDate,
                daysWishlisted: null
            }

            if (wishAddDate) {
                var endDate = isCurrentlyWishlisted ? Util.time() : (wishRemoveDate ? wishRemoveDate : Util.time())
                wishlistData.daysWishlisted = Math.max(1, Math.ceil((endDate - wishAddDate) / Constants.TIME_DAY))
            }
        }

        return {
            context: {
                collection: collectionData,
                rating: ratingData,
                plays: playsData,
                wishlist: wishlistData
            }
        }

    }
})
